import deliveriesDataReducer from './deliveriesDataReducer';
import deliveryDataReducer from './DeliveryDataReducer';
import deliveryDocumentsReducer from './DeliveryDocumentsReducer';
import deliveryLinesByDeliveryIdReducer from './DeliveryLinesByDeliveryIdReducer';
import { combineReducers } from '@reduxjs/toolkit';

export const deliveryReducers = combineReducers({
	deliveries: deliveriesDataReducer,
	detail: deliveryDataReducer,
	detail_documents: deliveryDocumentsReducer,
	detail_lines: deliveryLinesByDeliveryIdReducer
});